import { Fragment,useEffect,useState } from 'react';
import { Switch } from "@progress/kendo-react-inputs";
import { Chart, ChartLegend, ChartArea, ChartTooltip, ChartSeries, ChartSeriesItem, RenderEvent, SeriesVisualArgs } from '@progress/kendo-react-charts';
import 'hammerjs';
import { ExpansionPanel, ExpansionPanelContent } from '@progress/kendo-react-layout';
import { Circle as CircleGeometry } from '@progress/kendo-drawing/geometry';
import { Layout, Text } from '@progress/kendo-drawing';

export const AverageWeekPdf = (props: any) => {
    const [isPublicHolidayToggleChecked, setIsPublicHolidayToggleChecked] = useState<any>(false);
    const [isLeaveToggleChecked, setIsLeaveToggleChecked] = useState<any>(false);

    //category and subcategory
    const [categories, setCategories] = useState<any>([])
    const [subCategories, setSubCategories] = useState<any>([])

    //total hours minutes
    const [totalHours, setTotalHours] = useState<any>();
    const [totalMinutes, setTotalMinutes] = useState<any>();

    //total Session
    const [totalSessions, setTotalSessions] = useState<any>();

    //DCC and ICC exceeded
    const [dccExceedsContracted, setDccExceedsContracted] = useState(false);
    const [iccDccExceedsContracted, setIccDccExceedsContracted] = useState(false);

    //ICC and Contract Percentage
    const [iccPercentage, setIccPercentage] = useState<any>();
    const [contractPercentage, setContractPercentage] = useState<any>();

    //Aggregate Contract and Worked Percentage
    const [aggregateContractPercentage, setAggregateContractPercentage] = useState<any>();

    //Aggregate ICC and DCC Percentage
    const [aggregateIccDccPercentage, setAggregateIccDccPercentage] = useState<any>();

    useEffect(() => {
        props.setAverageWeekData.categories.forEach((element: any) => {
            element.totalDurationMinutes = (element.totalHours * 60) + element.totalMinutes;
        });
        setCategories(props.setAverageWeekData.categories);
        props.setAverageWeekData.subCategories.forEach((element: any) => {
            element.totalDurationMinutes = (element.totalHours * 60) + element.totalMinutes;
        });
        setSubCategories(props.setAverageWeekData.subCategories);
        setTotalSessions(props.setAverageWeekData.totalSessions);
        setTotalHours(props.setAverageWeekData.totalHours);
        setTotalMinutes(props.setAverageWeekData.totalMinutes);
        setDccExceedsContracted(props.setAverageWeekData.dccExceedsContracted);
        setIccDccExceedsContracted(props.setAverageWeekData.iccDccExceedsContracted);
        setIccPercentage(props.setAverageWeekData.iccPercentage);
        setContractPercentage(props.setAverageWeekData.contractPercentage);
        setAggregateContractPercentage(props.setAverageWeekData.aggregateContractPercentage);
        setAggregateIccDccPercentage(props.setAverageWeekData.aggregateIccDccPercentage)
        setIsLeaveToggleChecked(props.setAverageWeekData.isLeaveToggelChecked);
        setIsPublicHolidayToggleChecked(props.setAverageWeekData.isPublicHolidayToggelChecked);
    },[]);

    //donut center circle values
    let center: any;
    let radius: any;

    //To create visuals for donut chart center
    const visualHandler = (e: SeriesVisualArgs) => {
        // Obtain parameters for the segments
        center = e.center;
        radius = e.innerRadius;

        // Create default visual
        return e.createVisual();
    };

    //To render the donut chart center
    const onRender = (e: RenderEvent) => {
        // The center and radius are populated by now.
        // We can ask a circle geometry to calculate the bounding rectangle for us.
        if (center) {
            const circleGeometry = new CircleGeometry([center.x, center.y], radius);
            const bbox = circleGeometry.bbox();

            // Render the text
            const heading = new Text(Math.floor(totalHours) + 'h ' + totalMinutes.toFixed(1) + 'm', [0, 0], {
                font: "bold 20px Helvetica Now,Helvetica,Arial,'sans- serif'",
            });

            // Reflow the text in the bounding box
            const layout = new Layout(bbox, {
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                spacing: 5,
                orientation: 'vertical'
            });

            layout.append(heading);
            layout.reflow();

            // Draw it on the Chart drawing surface
            if (e.target.surface) {
                e.target.surface.draw(layout);
            }
        }
    };

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-5 mb-2 p-0">
                        <div className="mb-0">
                            {props.setAverageWeekData.isPublicHolidayToggelChecked &&
                                <Switch size="small" defaultChecked={true} onLabel={""} offLabel={""} />
                            }
                            {!props.setAverageWeekData.isPublicHolidayToggelChecked &&
                                <Switch size="small" defaultChecked={false} onLabel={""} offLabel={""} />
                            }
                            <label className="form-check-label fs-5 ms-2">Exclude weeks with public holidays</label>
                        </div>
                        <div className="mb-0">
                            {props.setAverageWeekData.isLeaveToggelChecked &&
                                <Switch size="small" defaultChecked={true} onLabel={""} offLabel={""} />
                            }
                            {!props.setAverageWeekData.isLeaveToggelChecked &&
                                <Switch size="small" defaultChecked={false} onLabel={""} offLabel={""} />
                            }
                            <label className="form-check-label fs-5 ms-2">Exclude weeks with leave</label>
                        </div>
                        {totalHours == 0 && totalMinutes == 0 && (<p>No activities in diary for this week.</p>)}
                    </div>
                </div>
            </div>
            <div className="Container-fluid">
                <div className="row">
                    <div className="col-lg-6">
                        <Chart transitions={false} onRender={onRender}>
                            <ChartTooltip background="#fff" />
                            <ChartLegend visible={false} />
                            <ChartArea background="none" />
                            <ChartSeries>
                                <ChartSeriesItem visual={visualHandler}
                                    name="subCategories"
                                    data={subCategories}
                                    width={500}
                                    type="donut"
                                    startAngle={0}
                                    field="totalDurationMinutes"
                                    categoryField="name"
                                    colorField="color"
                                    size={40}
                                    holeSize={50}
                                    margin={3}
                                >
                                </ChartSeriesItem>
                                <ChartSeriesItem visual={visualHandler}
                                    name="categories"
                                    data={categories}
                                    width={500}
                                    type="donut"
                                    startAngle={0}
                                    field="totalDurationMinutes"
                                    categoryField="name"
                                    colorField="color"
                                    size={60}
                                    holeSize={50}
                                    margin={3}
                                >
                                </ChartSeriesItem>
                            </ChartSeries>
                        </Chart>

                        {dccExceedsContracted && (
                            <span className="red-text mb-2">
                                <svg width="16" height="16" fill="red" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                                </svg>&nbsp;
                                <p className="mb-0">Average DCC is more than contracted hours.</p>
                            </span>
                        )}
                        {iccDccExceedsContracted && (
                            <span className="red-text mb-2">
                                <svg width="16" height="16" fill="red" viewBox="0 0 16 16">
                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM4.5 7.5a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7z" />
                                </svg>&nbsp;
                                <p className="mb-0">Average total of DCC and ICC is more than contracted hours.</p>
                                <br />
                            </span>
                        )}
                        <div>
                            {iccPercentage > 0 && (
                                <p className="mb-1">Your average ICC is {iccPercentage.toFixed(0)}% of your DCC plus ICC time.</p>)}
                        </div>
                        <div>
                            {aggregateIccDccPercentage > 0 && iccPercentage > 0 && (
                                <p className="text-secondary mb-1">Other GP Diary users find ICC is {aggregateIccDccPercentage.toFixed(0)}% of DCC plus ICC time.</p>)}
                        </div>
                        <div>
                            {contractPercentage > 0 && (
                                <p className="mb-1">Your average contract hours are {contractPercentage.toFixed(0)}% of your worked total.</p>)}
                        </div>
                        <div>
                            {aggregateContractPercentage > 0 && contractPercentage > 0 && (
                                <p className="text-secondary mb-1">Other GP Diary users find their contract hours are {aggregateContractPercentage.toFixed(0)}% of their total hours.</p>)}
                        </div>
                    </div>
                    <div className="col-lg-2"></div>
                    <div className="col-lg-4 mt-5">
                        {categories.map((item: any, index: any) => (
                            <Fragment key={index}>
                                <ExpansionPanel
                                    expandIcon="k-icon k-i-arrow-60-right"
                                    collapseIcon="k-icon k-i-arrow-60-down"
                                    style={{ border: 'none', borderBottom: "2px solid lightgrey" }}
                                    expanded={true}
                                    tabIndex={0}
                                    key={item.id}
                                    title={
                                        <div className="row mt-2">
                                            <span className="mr-2">
                                                <svg width="50" height="50">
                                                    <circle cx="25" cy="25" r="25" fill={item.color} fillOpacity="0.3" />
                                                    <circle cx="25" cy="25" r="15" fill={item.color} fillOpacity="0.7" />
                                                    <circle cx="25" cy="25" r="5" fill={item.color} fillOpacity="1" />
                                                </svg>
                                                <label className="text-dark ps-2">{item.name} - {item.totalHours.toFixed(0)}h {item.totalMinutes.toFixed(1)}m ({item?.percentage > 0 ? item?.percentage?.toFixed(1) : 0}%)</label>
                                            </span>
                                        </div>
                                    }
                                />
                                {subCategories.filter((x: any) => x.categoryId == item.id).map((sub: any, index: any) => (
                                    <Fragment key={index}>
                                        {true && (
                                            <div className="container-fluid">
                                                <ExpansionPanelContent>
                                                    <div className="row mt-2">
                                                        <span className="col-1 ps-4 ms-1">
                                                            <svg width="20" height="20">
                                                                <circle cx="10" cy="10" r="10" fill={sub.color} />
                                                            </svg>
                                                        </span>
                                                        <label className="col-5 ps-4 ms-1 pe-0 text-break">{sub.name}</label>
                                                        <label className="col-5 ps-1 pe-0 text-break">{sub.totalHours.toFixed(0)}h {sub.totalMinutes.toFixed(1)}m ({sub?.percentage > 0 ? sub?.percentage?.toFixed(1) : 0}%)</label>
                                                    </div>
                                                </ExpansionPanelContent>
                                            </div>
                                        )}
                                    </Fragment>
                                ))}
                            </Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}